import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';

export const multiSearch = query => ({
  type: actionsTypes.MULTI_SEARCH,
  payload: API.multi_search(query),
});
